import styled, { css, ThemeContext } from 'styled-components';
import { useContext } from 'react';
import rem from 'polished/lib/helpers/rem';
import Typography from '../../base/Typography';

export const DivItemContainerStyled = styled.div`
  ${({ theme, variant }) => css`
    padding: ${rem(22)} 0;
    /** #DFDFDF not in theme, should it be? */
    border-bottom: 1px solid #dfdfdf;
    :first-of-type {
      border-top: 1px solid #dfdfdf;
    }

    ${variant === 'secondary'
      && `
      background-color: ${theme.colors.neutral.gray95};
      margin-bottom: 1rem;
      border: 0;
      padding: ${rem(24)};
    `}
  `}
`;

export const ButtonContainerStyled = styled.button`
  ${({ theme, variant }) => css`
    background: inherit;
    border: 0;
    display: flex;
    position: relative;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    color: ${theme.colors.neutral.gray29};
    &.is-accordion-item-expanded {
      ${variant === 'primary'
        && `
        color: ${theme.colors.primary.blue};
        .accordion-toggle-icon {
          color: ${theme.colors.primary.blue};
        }
      `}
    }
    &:hover {
      cursor: pointer;
      color: ${theme.colors.primary.blue};
      .accordion-toggle-icon {
        color: ${theme.colors.primary.blue};
      }
    }
    :focus {
      outline: auto 5px -webkit-focus-ring-color;
    }
  `}
`;

export const DdItemContainer = styled.dd`
  margin: 0;
  padding-top: ${rem(16)};
`;

export const DtItemContainer = styled.dt`
  width: 100%;
`;

export const TypographyTitleStyled = styled(Typography)`
  ${({ leftPadding, variant }) => css`
  flex: 1 1 auto;

  ${variant === 'primary'
    && `
    font-size: ${rem(17)};
  `}

  padding-top: ${rem(6)};
  ${leftPadding
    && css`
      padding-left: 1rem;
    `}
  `}
`;

export const TypographyContentStyled = styled(Typography)`
  padding-left: 0.5rem;
`;

/** Creates inline styles (to override stock Component Library styles) */
export const Styles = () => {
  const theme = useContext(ThemeContext);

  return {
    TitleIconStyled: {
      flexShrink: 0,
      width: rem(28),
      height: '100%',
    },
    IconToggleStyled: variantType => ({
      flexShrink: 0,
      color: theme.colors.cta.blue,
      paddingLeft: variantType === 'primary' ? rem(10) : 0,
    }),
  };
};
